import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "row no-gutters pt-45 px-sm-5 px-3" };
const _hoisted_2 = { class: "loginSection mx-auto pt-2 px-sm-45 px-0 bg-white font6-responsive" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = {
    name: "registerForm",
    class: "w-100"
};
const _hoisted_5 = { class: "col-12 pt-4" };
const _hoisted_6 = { class: "row pl-1" };
const _hoisted_7 = { class: "col-4 pl-0 pr-1" };
const _hoisted_8 = { class: "col-4 pl-0 pr-1" };
const _hoisted_9 = { class: "col-4 pl-0 pr-0" };
const _hoisted_10 = { class: "col-12 pb-3" };
const _hoisted_11 = { class: "col-12 pb-3" };
const _hoisted_12 = { class: "col-12 pb-3" };
const _hoisted_13 = { class: "col-12 pb-3" };
const _hoisted_14 = { class: "col-12 pb-45" };
const _hoisted_15 = { class: "col-12 mb-3" };
const _hoisted_16 = ["disabled"];
const _hoisted_17 = /*#__PURE__*/ _createStaticVNode("<div class=\"row\"><div class=\"col-12 font7-responsive text-left\"><p class=\"pb-6\"> Mit der Registrierung erklärst Du Dich mit den <a href=\"/agb\" target=\"_blank\" title=\"AGB\" class=\"link-in-text\">AGB</a> und <a href=\"/datenschutz\" target=\"_blank\" title=\"Datenschutz\" class=\"link-in-text\"> Datenschutzbestimmungen </a> von <span class=\"d-inline-block\">mySWOOOP</span> einverstanden. </p></div></div>", 1);
import axios from 'axios';
import { computed, ref } from 'vue';
import BaseInput from '@/components/Base/Forms/Inputs/BaseInput.vue';
import BaseEmailInput from '@/components/Base/Forms/Inputs/BaseEmailInput.vue';
import { emailRequiredRule, passwordRule, firstNameRule, lastNameRule } from '@/helpers/ValidationRules';
import eventBus from '@/services/EventBus';
export default /*#__PURE__*/ _defineComponent({
    __name: 'RegisterForm',
    setup(__props) {
        const gender = ref('');
        const firstName = ref('');
        const lastName = ref('');
        const email = ref('');
        const password = ref('');
        const passwordConfirm = ref('');
        // Extending der passwordRule mit eigener Erweiterung
        const passwordConfirmationRule = passwordRule.test('NameDerRegelEgal_PasswordConfirmation', 'Das Passwort muss gleich sein.', (value) => {
            return value === password.value;
        });
        // Inputs valid:
        const firstNameValid = ref(false);
        const lastNameValid = ref(false);
        const emailValid = ref(false);
        const passwordValid = ref(false);
        const passwordConfirmValid = ref(false);
        const registerPossible = computed(() => {
            return (passwordValid.value &&
                passwordConfirmValid.value &&
                emailValid.value &&
                lastNameValid.value &&
                firstNameValid.value);
        });
        function handleRegisterSubmit() {
            axios
                .post('/auth/register', {
                customers_gender: gender.value,
                customers_firstname: firstName.value,
                customers_lastname: lastName.value,
                customers_email_address: email.value,
                password: password.value,
                password_validate: passwordConfirm.value,
            })
                .then(() => {
                eventBus.emit('openInfoPopup', {
                    icon: 'info',
                    headline: 'Registrierung',
                    message: 'Du hast Dich erfolgreich registriert!',
                });
                eventBus.emit('LoggedIn');
                setTimeout(() => {
                    eventBus.emit('closeRegisterPopup');
                }, 1500);
            })
                .catch((error) => {
                switch (error.response.status) {
                    case 410:
                        eventBus.emit('openInfoPopup', {
                            icon: 'info',
                            headline: 'Du bist bereits angemeldet',
                            message: 'Sieht so aus, als hättest du dich schon eingeloggt.',
                        });
                        return;
                    case 409:
                        eventBus.emit('openInfoPopup', {
                            icon: 'error',
                            headline: 'E-Mail bereits vorhanden',
                            message: 'Diese E-Mail Adresse existiert bereits!',
                        });
                        return;
                    case 429:
                        eventBus.emit('openInfoPopup', {
                            icon: 'error',
                            headline: 'Du wurdest vorübergehend gesperrt',
                            message: 'Aufgrund zu vieler Anfragen ist die Registrierung für diese IP-Adresse für 24h gesperrt.',
                        });
                        return;
                    case 422:
                        eventBus.emit('openInfoPopup', {
                            icon: 'error',
                            headline: 'Ein Fehler ist aufgetreten',
                            message: 'Bitte überprüfe deine Eingaben. E-Mail Adresse bereits in Verwendung?',
                        });
                        return;
                    default:
                        eventBus.emit('openInfoPopup', {
                            icon: 'error',
                            headline: 'Ein Fehler ist aufgetreten',
                            message: 'Alle Eingaben korrekt? Bitte überprüfe noch einmal alles oder wende dich gerne an unseren Support.',
                        });
                }
            });
        }
        return (_ctx, _cache) => {
                                                                    
                                                                                
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("section", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("form", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_v_radio_group, {
                                    modelValue: gender.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((gender).value = $event))
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_6, [
                                            _createElementVNode("div", _hoisted_7, [
                                                _createVNode(_component_v_radio, {
                                                    label: "Herr",
                                                    value: "m"
                                                })
                                            ]),
                                            _createElementVNode("div", _hoisted_8, [
                                                _createVNode(_component_v_radio, {
                                                    label: "Frau",
                                                    value: "f"
                                                })
                                            ]),
                                            _createElementVNode("div", _hoisted_9, [
                                                _createVNode(_component_v_radio, {
                                                    label: "Divers",
                                                    value: "d"
                                                })
                                            ])
                                        ])
                                    ]),
                                    _: 1
                                }, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createVNode(BaseInput, {
                                    placeholder: "Vorname",
                                    modelValue: firstName.value,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((firstName).value = $event)),
                                    name: "firstName",
                                    rules: _unref(firstNameRule),
                                    class: "showValidationErrorsCssOverride",
                                    onChanged: _cache[2] || (_cache[2] = (event) => (firstNameValid.value = event.valid))
                                }, null, 8, ["modelValue", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                                _createVNode(BaseInput, {
                                    placeholder: "Nachname",
                                    modelValue: lastName.value,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((lastName).value = $event)),
                                    name: "lastName",
                                    rules: _unref(lastNameRule),
                                    class: "showValidationErrorsCssOverride",
                                    onChanged: _cache[4] || (_cache[4] = (event) => (lastNameValid.value = event.valid))
                                }, null, 8, ["modelValue", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                                _createVNode(BaseEmailInput, {
                                    placeholder: "E-Mail",
                                    id: "email",
                                    modelValue: email.value,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((email).value = $event)),
                                    label: "E-Mail",
                                    name: "email",
                                    rules: _unref(emailRequiredRule),
                                    class: "showValidationErrorsCssOverride",
                                    onChanged: _cache[6] || (_cache[6] = (event) => (emailValid.value = event.valid))
                                }, null, 8, ["modelValue", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                                _createVNode(BaseInput, {
                                    placeholder: "Passwort",
                                    modelValue: password.value,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((password).value = $event)),
                                    inputType: "password",
                                    name: "password",
                                    rules: _unref(passwordRule),
                                    class: "showValidationErrorsCssOverride",
                                    onChanged: _cache[8] || (_cache[8] = (event) => (passwordValid.value = event.valid))
                                }, null, 8, ["modelValue", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                                _createVNode(BaseInput, {
                                    placeholder: "Passwort wiederholen",
                                    modelValue: passwordConfirm.value,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((passwordConfirm).value = $event)),
                                    name: "passwordConfirm",
                                    rules: _unref(passwordConfirmationRule),
                                    inputType: "password",
                                    class: "showValidationErrorsCssOverride",
                                    onChanged: _cache[10] || (_cache[10] = (event) => (passwordConfirmValid.value = event.valid))
                                }, null, 8, ["modelValue", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("button", {
                                    disabled: !registerPossible.value,
                                    class: _normalizeClass([{ buttonDisabled: !registerPossible.value }, "buttonBase buttonGreen font6-responsive w-100 strong [ track_finish-register ]"]),
                                    onClick: _cache[11] || (_cache[11] = ($event) => (handleRegisterSubmit())),
                                    type: "button",
                                    id: "register"
                                }, " Registrieren ", 10, _hoisted_16)
                            ])
                        ])
                    ]),
                    _hoisted_17
                ])
            ]));
        };
    }
});


/* Vuetify */
import { VRadio as _component_v_radio } from "vuetify/lib/components/VRadio/index.mjs"
import { VRadioGroup as _component_v_radio_group } from "vuetify/lib/components/VRadioGroup/index.mjs"

